import ChartMakeRunNowConfirmation from './ChartMakeRunNowConfirmation';

export default ChartMakeRunNowConfirmation;
